import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

export function VerifyEmailPage() {
  const { api } = useAuth();
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: 'loading', message: '' });
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get('token');
    if (!token) {
      setState({ status: 'error', message: 'Missing verification token.' });
      return;
    }
    api.post('/api/auth/verify-email', { token })
      .then(({ data }) => setState({ status: 'ok', message: `${data.email} is now verified.` }))
      .catch((e) => setState({ status: 'error', message: e.response?.data?.detail || 'Verification failed.' }));
  }, [api, params]);

  const Icon = state.status === 'ok' ? CheckCircle2 : state.status === 'error' ? XCircle : Loader2;
  const color = state.status === 'ok' ? 'text-[#00E676]' : state.status === 'error' ? 'text-[#FF5252]' : 'text-[#00E5FF] animate-spin';

  return (
    <div className="min-h-screen bg-[#000B18] flex items-center justify-center p-6" data-testid="verify-email-page">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[#041A3B] p-8 text-center">
        <Icon className={`w-14 h-14 mx-auto mb-4 ${color}`} />
        <h1 className="font-outfit text-2xl font-semibold text-white mb-2" data-testid="verify-email-title">
          {state.status === 'ok' ? 'Email verified' : state.status === 'error' ? 'Link not valid' : 'Verifying…'}
        </h1>
        <p className="text-[#A0B4CC] text-sm mb-6" data-testid="verify-email-message">{state.message}</p>
        {state.status !== 'loading' && (
          <Link
            to="/dashboard"
            className="inline-block rounded-full bg-[#00E5FF] text-[#000B18] font-semibold px-6 py-2 hover:bg-[#5CF0FF] transition-colors"
            data-testid="verify-email-continue-btn"
          >
            Continue to dashboard
          </Link>
        )}
      </div>
    </div>
  );
}
